import React from 'react';
import { Row, Col } from 'reactstrap';

import App_data from '../../../config/App_data';

function VideoReport({
  videoId,
  setContent,
  successAlert,
  reportLoading,
  reportContent,
  onReportVideo,
  toggleReportSection,
}) {
  return (
    <Row>
      <Col>
        <div className='card'>
          <div className='card-header'>Report</div>
          {!successAlert ? (
            <div className='card-block'>
              <label className='form-control-label' htmlFor='textarea-input'>
                <strong>Comment</strong>
              </label>
              <textarea
                id='comment'
                name='comment'
                rows='6'
                className='form-control'
                placeholder='Content..'
                onBlur={setContent}
                value={reportContent}
              />
              <div className='mt-1'>
                <button
                  type='button'
                  className='btn btn-primary active pointer_class report-btn'
                  disabled={reportLoading}
                  onClick={() => onReportVideo(videoId)}
                >
                  {reportLoading ? 'Please Wait' : 'Report'}
                </button>
                <button
                  type='button'
                  className='btn btn-danger active pointer_class margin_left_10'
                  onClick={toggleReportSection}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div className='report-Success-card card-block'>
              <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
              <label className='form-control-label' htmlFor='textarea-input'>
                <strong> Your report has been submitted successfully.</strong>
              </label>
              <button
                type='button'
                className='btn btn-primary active pointer_class  min-vw-120'
                onClick={toggleReportSection}
              >
                Close
              </button>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
}

export default VideoReport;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/VideoDisplay/VideoReport.jsx